import React from "react";



const Error = () => {
    
    return (
    <>
    <h1>  OOppss! Page not found </h1>
     </>

    );

};
export default Error;